<div class="modal modal-confirm">
  <div class="modal-header">
    <span>Atenção</span>
  </div>  
  <div class="modal-content">
    <article class="message alert alert-info" [innerHtml]="data.message">
    </article>    
  </div>
  <div class="modal-footer">
    <button type="modal" class="btn btn-one" (click)="send()">
      SIM
    </button> 
    <button type="modal" class="btn btn-one not" (click)="close()">
      NÃO
    </button> 
  </div>   
</div>
    